import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'reactstrap'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import GenresSelectionGuide from './GenresSelectionGuide'

type GenresSelectionGuideModalProps = {
  toggle: (arg0: boolean) => void
  isOpen: boolean
}
const GenresSelectionGuideModal: FunctionComponent<GenresSelectionGuideModalProps> = ({
  toggle,
  isOpen,
}) => {
  const { t } = useTranslation()

  const onModalClose = () => {
    toggle(false)
  }

  return (
    <Modal
      fade={false}
      className="modal__mobile-dialog"
      isOpen={isOpen}
      modalClassName="modal__mobile"
      toggle={onModalClose}
    >
      <div className="modal__mobile-header">
        <div />
        <button
          className="lnr lnr-cross modal__mobile-close"
          type="button"
          onClick={onModalClose}
        />
      </div>
      <GenresSelectionGuide />
      <div className="apply_btn">
        <WhiteGreenBtn color="white" onClick={onModalClose}>
          {t('scheduleCampaignPage.gotIt')}
        </WhiteGreenBtn>
      </div>
    </Modal>
  )
}
export default GenresSelectionGuideModal
